export function sendEvent(name, params) {
  if (typeof window !== 'undefined' && typeof window.gtag === 'function') {
    window.gtag('event', name, params);
  }
}

export function trackPageView(location) {
  sendEvent('page_view', {
    page_location: window.location.href,
    page_path: `${location.pathname}${location.search}${location.hash}`,
    page_title: document.title,
  });
}

export function classifyHighIntentInteraction(element, path) {
  const href = element.getAttribute('href') || '';
  const label = (element.textContent || '').trim().replace(/\s+/g, ' ').slice(0, 80);

  if (href.startsWith('tel:')) {
    return {
      name: 'contact',
      params: { contact_method: 'phone', page_path: path },
    };
  }

  if (href.startsWith('mailto:')) {
    return {
      name: 'contact',
      params: { contact_method: 'email', page_path: path },
    };
  }

  if (/^https:\/\/(?:www\.)?calendly\.com\//i.test(href)) {
    return {
      name: 'contact',
      params: { contact_method: 'calendar', page_path: path },
    };
  }

  const isHighIntentLink = /\/(request-proposal|contact)(?:$|[?#])/.test(href);
  const isHighIntentLabel = /^(start a project|request proposal|request capability statement|book a 30-minute call)$/i.test(label);

  if (isHighIntentLink || isHighIntentLabel) {
    return {
      name: 'cta_click',
      params: {
        cta_label: label || href,
        cta_destination: href || 'form_submit_button',
        page_path: path,
      },
    };
  }

  return null;
}
